module.exports = __webpack_public_path__ + "static/media/awpartner-1.38672143.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/awpartner-1.jpg
// module id = 574
// module chunks = 6